import ResultRoot from './Result.root';

export default {
    Component: ResultRoot,
};
